import { Col, Row } from "react-bootstrap";
import CustomerProfileCard from "components/cards/CustomerProfileCard";
import SettingsCompanyInfo from "components/forms/SettingsCompanyInfo";
import SettingsPersonalInfo from "components/forms/SettingsPersonalInfo";
import SettingsChangePassword from "components/forms/SettingsChangePassword";

const Settings = () => {
  return (
    <Row className="g-5 align-items-start">
      <Col xs={12} xl={4}>
        <div className="sticky-top" style={{ top: '2rem' }}>
          <CustomerProfileCard />
        </div>
      </Col>
      <Col xs={12} xl={8}>
        <div style={{ 
          background: 'rgba(255, 255, 255, 0.02)',
          borderRadius: '16px',
          padding: '0'
        }}>
          <SettingsPersonalInfo />
        </div>
        {/* Additional settings sections can be uncommented as needed */}
        {/* <Row className="gx-3 mb-6 gy-6 gy-sm-3 mt-4">
          <Col xs={12} sm={6}>
            <SettingsCompanyInfo />
          </Col>
          <Col xs={12} sm={6}>
            <SettingsChangePassword />
          </Col>
        </Row> */}
      </Col>
    </Row>
  );
};

export default Settings;
